"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var attending_service_1 = require("../../service/attending.service");
var ShowAttendingComponent = /** @class */ (function () {
    function ShowAttendingComponent(_route, _attendingService) {
        this._route = _route;
        this._attendingService = _attendingService;
        this.setUpObservers();
        this.findAttending();
    }
    ShowAttendingComponent.prototype.ngOnInit = function () {
    };
    ShowAttendingComponent.prototype.findAttending = function () {
        var _this = this;
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                var attendingId = +params['id'];
                _this.showCurrent(attendingId);
            }
        });
    };
    ShowAttendingComponent.prototype.showCurrent = function (id) {
        this._attendingService.showCurrent(id);
    };
    ShowAttendingComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._attendingService.current$
            .subscribe(function (attending) {
            _this.attending = attending;
        });
    };
    ShowAttendingComponent.ctorParameters = function () { return [{ type: router_1.ActivatedRoute }, { type: attending_service_1.AttendingService }]; };
    return ShowAttendingComponent;
}());
exports.ShowAttendingComponent = ShowAttendingComponent;
//# sourceMappingURL=show-attending.component.js.map


// WEBPACK FOOTER //
// show-attending.component.js